import type { ReactNode } from 'react';
import { Switch as AriaSwitch, type SwitchProps as AriaSwitchProps } from 'react-aria-components';
import { cn } from '../lib/cn';

export interface SwitchProps extends Omit<AriaSwitchProps, 'className' | 'children'> {
  children: ReactNode;
  className?: string;
}

/** On/off for one thing ("Ganztägig") – the label is part of the touch target. */
export function Switch({ children, className, ...props }: SwitchProps) {
  return (
    <AriaSwitch
      {...props}
      className={cn(
        'group flex min-h-touch-min cursor-pointer items-center justify-between gap-gap-md font-semibold outline-none',
        className,
      )}
    >
      {children}
      <span className="flex h-7 w-12 shrink-0 items-center rounded-full bg-border-default p-0.5 transition group-data-focus-visible:outline-3 group-data-focus-visible:outline-border-focus group-data-selected:bg-action-primary">
        <span className="size-6 rounded-full bg-surface-raised transition group-data-selected:translate-x-5" />
      </span>
    </AriaSwitch>
  );
}
